import useKeydown from "@/hooks/useKeyDown";
import { BrandChevron } from "../Step";
import styles from "./ButtonWithDetails.module.scss";

type Props = {
  details: string;
  onClick(): void;
};

export default function ButtonWithDetails({
  details,
  onClick,
  children,
}: React.PropsWithChildren<Props>) {
  const onTriggered = () => {
    onClick();
  };

  const ref = useKeydown("Enter", onTriggered);

  return (
    <div
      className={styles.wrapper}
      onClick={onTriggered}
      tabIndex={1}
      ref={ref}
      role="button"
    >
      <div>
        <div>{children}</div>
        <div className={styles.details}>{details}</div>
      </div>
      <BrandChevron />
    </div>
  );
}
